module.exports = __webpack_public_path__ + "img/产品介绍.16307297.jpg";